export const gaugeProgressPercentage = (value: number, maxValue: number): number => {
  if (maxValue === 0 || value === 0) return 0;
  return Math.min((value / maxValue) * 100, 100);
};

/** Parses `MM:SS` or `HH:MM:SS` tokens (integer segments) → seconds */
export const parseClockToSeconds = (raw: string): number => {
  const parts = raw
    .trim()
    .split(":")
    .map((p) => Number(String(p).trim()));
  if (parts.length < 2 || parts.length > 3 || parts.some((n) => Number.isNaN(n))) {
    return 0;
  }
  if (parts.length === 2) {
    return parts[0] * 60 + parts[1];
  }
  return parts[0] * 3600 + parts[1] * 60 + parts[2];
};
